import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getSpacing } from '../utils';

const getWidth = props => {
  if (props.isIcon) {
    return '35px';
  }
  return props.width;
};

const getHeight = props => {
  if (props.isIcon) {
    return '20px';
  }
  return props.height;
};

const Image = styled.img`
  border-radius: 50%;
  margin: ${props => getSpacing(props.margin)};
  padding: ${props => getSpacing(props.padding)};
  width: ${props => getWidth(props)};
  height: ${props => getHeight(props)};
`;

Image.defaultProps = {
  margin: 'none',
  padding: 'none',
  width: '160px',
  height: '160px',
  src: '',
  isIcon: false
};

Image.propTypes = {
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  width: PropTypes.string,
  height: PropTypes.string,
  src: PropTypes.string,
  isIcon: PropTypes.bool
};

export { Image };
